import React from 'react';

export default function ToastRack({ toasts }) {
  return <ul className='toast-rack'>{toasts}</ul>;
}
